import React from 'react';
import Hero from './sections/Hero';
import Services from './sections/Services';
import Projects from './sections/Projects';
import Team from './sections/Team';
import CTA from './sections/CTA';
import AdBanner from '../../components/AdBanner';
import './Home.css';

export default function Home() {
    return (
        <div className="home">
            <Hero />

            {/* Bannière Hero - Après Hero */}
            <div className="ad-section">
                <AdBanner
                    slot="7999940754" // Votre slot pour la bannière Hero
                    format="auto"
                />
            </div>

            <Services />

            {/* Vous pouvez ajouter d'autres bannières ici avec leurs propres slots */}

            <Projects />

            <Team />

            <CTA />
        </div>
    );
}